import React from 'react'
import FormLogin from './FormLogin'
import { Grid } from 'semantic-ui-react'


const LoginContainer = ({ user, onLogin }) => {
    const { isLogged, isLogging, error } = user
    if (isLogged)
        return null

    return (<div>
        <Grid style={{ height: '100%', paddingTop: '4em' }} textAlign='center' verticalAlign='middle'>
            <Grid.Column style={{ maxWidth: '450px' }}>
                <FormLogin onLogin={onLogin} error={error} loading={isLogging} />
            </Grid.Column>
        </Grid>
    </div>)
}

export default LoginContainer


// WEBPACK FOOTER //
// ./src/components/LoginContainer.js